"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clipboardTextToYesNo = exports.clipboardYesNoSelf = exports.clipboardTextToAutonumber = exports.clipboardTextToRating = exports.clipboardNumberToRating = exports.clipboardToSelf = exports.clipboardSliderToSelf = exports.clipboardTextToSlider = exports.clipboardNumberToNumber = exports.clipboardTextToNumber = exports.clipboardCountToNumber = exports.textToDoc = exports.textToDocValue = exports.clipboardAnyToText = exports.textPasteRules = exports.clipboardRecordIdToText = exports.copyTextToClipboard = void 0;
const types_1 = require("@smartsuite/types");
const bignumber_js_1 = require("bignumber.js");
const number_1 = require("./number");
const texts_1 = require("../texts");
const intl_1 = require("../locale/intl");
const parsers_1 = require("@smartsuite/smartdoc/lib/esm/helpers/parsers");
const copyTextToClipboard = (text) => {
    const textArea = document.createElement("textarea");
    // Place in top-left corner of screen regardless of scroll position.
    textArea.style.position = "fixed";
    textArea.style.top = "0";
    textArea.style.left = "0";
    // Ensure it has a small width and height. Setting to 1px / 1em
    // doesn't work as this gives a negative w/h on some browsers.
    textArea.style.width = "2em";
    textArea.style.height = "2em";
    // We don't need padding, reducing the size if it does flash render.
    textArea.style.padding = "0";
    // Clean up any borders.
    textArea.style.border = "none";
    textArea.style.outline = "none";
    textArea.style.boxShadow = "none";
    // Avoid flash of white box if rendered for any reason.
    textArea.style.background = "transparent";
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
        document.execCommand("copy");
    }
    catch (error) {
        throw new Error(`Oops, unable to copy ${String(error)}`);
    }
    document.body.removeChild(textArea);
};
exports.copyTextToClipboard = copyTextToClipboard;
function clipboardRecordIdToText(clipboardValue, _srcField, _targetField, _userPreferences) {
    var _a;
    return (_a = clipboardValue.rawValue) !== null && _a !== void 0 ? _a : "";
}
exports.clipboardRecordIdToText = clipboardRecordIdToText;
exports.textPasteRules = {
    recordidfield: clipboardRecordIdToText,
    textfield: clipboardAnyToText,
    recordtitlefield: clipboardAnyToText,
    textareafield: clipboardAnyToText,
    richtextareafield: clipboardAnyToText,
    datefield: clipboardAnyToText,
    singleselectfield: clipboardAnyToText,
    multipleselectfield: clipboardAnyToText,
    daterangefield: clipboardAnyToText,
    timefield: clipboardAnyToText,
    numberfield: clipboardAnyToText,
    numbersliderfield: clipboardAnyToText,
    percentfield: clipboardAnyToText,
    currencyfield: clipboardAnyToText,
    emailfield: clipboardAnyToText,
    phonefield: clipboardAnyToText,
    addressfield: clipboardAnyToText,
    fullnamefield: clipboardAnyToText,
    linkfield: clipboardAnyToText,
    yesnofield: clipboardAnyToText,
    filefield: clipboardAnyToText,
    linkedrecordfield: clipboardAnyToText,
    subitemsfield: clipboardAnyToText,
    firstcreatedfield: clipboardAnyToText,
    lastupdatedfield: clipboardAnyToText,
    userfield: clipboardAnyToText,
    ratingfield: clipboardAnyToText,
    votefield: clipboardAnyToText,
    tagsfield: clipboardAnyToText,
    socialnetworkfield: clipboardAnyToText,
    duedatefield: clipboardAnyToText,
    durationfield: clipboardAnyToText,
    percentcompletefield: clipboardAnyToText,
    statusfield: clipboardAnyToText,
    checklistfield: clipboardAnyToText,
    timetrackingfield: clipboardAnyToText,
    countfield: clipboardAnyToText,
    rollupfield: clipboardAnyToText,
    lookupfield: clipboardAnyToText,
    formulafield: clipboardAnyToText,
    autonumberfield: clipboardAnyToText,
    signaturefield: clipboardAnyToText,
    colorpickerfield: clipboardAnyToText,
    ipaddressfield: clipboardAnyToText,
    unknownfield: clipboardAnyToText,
};
function clipboardAnyToText(clipboardValue, srcField, targetField, _preferences, currentValue) {
    const newValueIsEmpty = !clipboardValue.text.replace(/\n/g, " ").trim();
    if (newValueIsEmpty && !targetField.params.required) {
        return "";
    }
    if (newValueIsEmpty && targetField.params.required && currentValue) {
        return currentValue;
    }
    const maxLength = targetField.params.max_length;
    if (maxLength) {
        return clipboardValue.text.slice(0, +maxLength);
    }
    return clipboardValue.text;
}
exports.clipboardAnyToText = clipboardAnyToText;
const textToDocValue = (text) => {
    const fieldValue = (0, parsers_1.parseJSONToFieldValue)(text);
    if (typeof fieldValue === "object" && fieldValue !== null) {
        return fieldValue;
    }
    return {
        data: (0, parsers_1.parseHTMLToDoc)(text),
        html: `<p>${text}</p>`,
        preview: text,
    };
};
exports.textToDocValue = textToDocValue;
function textToDoc(clipboardValue, _srcField, targetField, _userPreferences, currentValue) {
    const newValueIsEmpty = !clipboardValue.text.replace(/\n/g, " ").trim();
    if (newValueIsEmpty && targetField.params.required && currentValue) {
        return currentValue;
    }
    return (0, exports.textToDocValue)(clipboardValue.text);
}
exports.textToDoc = textToDoc;
const clipboardCountToNumber = (clipboardValue, _srcField, _targetField, _userPreferences, currentValue) => {
    if (!clipboardValue.rawValue)
        return currentValue;
    return clipboardValue.rawValue;
};
exports.clipboardCountToNumber = clipboardCountToNumber;
const clipboardTextToNumber = (clipboardValue, srcField, targetField, userPreferences, currentValue) => {
    var _a;
    const newValueIsEmpty = !clipboardValue.text.replace(/\n/g, " ").trim();
    if (newValueIsEmpty && !targetField.params.required) {
        return null;
    }
    const regex = (0, number_1.getNumberRegex)(types_1.MAX_PRECISION + 1, true, false, false);
    const locale = userPreferences.locale.value;
    const text = cleanupNumberText(clipboardValue.text, locale);
    const match = regex.exec(text);
    if (!!match && match[0] !== "") {
        const value = match[0];
        const decimalFormat = {
            decimalSeparator: ".",
            groupSeparator: "",
            groupSize: 3,
        };
        bignumber_js_1.BigNumber.config({ FORMAT: decimalFormat });
        const numberValue = new bignumber_js_1.BigNumber(value);
        const maxValue = "9".repeat(20);
        if (numberValue.gt(maxValue) || numberValue.lt(`-${maxValue}`)) {
            return currentValue;
        }
        const precision = (0, number_1.getDecimalPlacesNum)(value);
        const isValueValid = (((_a = targetField.params.allow_negative) !== null && _a !== void 0 ? _a : false) && numberValue.lt(0)) ||
            numberValue.gte(0);
        if (isValueValid) {
            return parseFloat(numberValue.toFormat(precision));
        }
        return currentValue;
    }
    return currentValue;
};
exports.clipboardTextToNumber = clipboardTextToNumber;
const clipboardNumberToNumber = (clipboardValue, srcField, targetField, userPreferences, currentValue) => {
    var _a;
    if (clipboardValue.rawValue === null || clipboardValue.rawValue === undefined)
        return null;
    const decimalFormat = {
        decimalSeparator: ".",
        groupSeparator: "",
        groupSize: 3,
    };
    bignumber_js_1.BigNumber.config({ FORMAT: decimalFormat });
    const bigNumberValue = new bignumber_js_1.BigNumber(clipboardValue.rawValue);
    const precision = (0, number_1.getDecimalPlacesNum)(String(clipboardValue.rawValue));
    const value = (bigNumberValue.lt(0) && ((_a = targetField.params.allow_negative) !== null && _a !== void 0 ? _a : false)) ||
        bigNumberValue.gte(0)
        ? bigNumberValue.toFormat(precision)
        : currentValue;
    if (value === null || typeof value === "number") {
        return value;
    }
    return parseFloat(value);
};
exports.clipboardNumberToNumber = clipboardNumberToNumber;
const clipboardTextToSlider = (clipboardValue, srcField, targetField, userPreferences, currentValue) => {
    var _a;
    const newValueIsEmpty = !clipboardValue.text.replace(/\n/g, " ").trim();
    if (newValueIsEmpty && !targetField.params.required) {
        return null;
    }
    if ((srcField === null || srcField === void 0 ? void 0 : srcField.field_type) === "ratingfield") {
        return Number(clipboardValue.rawValue);
    }
    // precision == 0 because we do not need decimal places
    // for a PercentComplete and NumberSlider fields;
    // also, we do not need to pass locale
    // because we need an ability to parse text both with ',' and '.' regardless of locale;
    const regex = (0, number_1.getNumberRegex)(0, true, false, false);
    let text = (srcField === null || srcField === void 0 ? void 0 : srcField.field_type) === "autonumberfield"
        ? (_a = clipboardValue.rawValue) !== null && _a !== void 0 ? _a : ""
        : clipboardValue.text;
    const locale = userPreferences.locale.value;
    if (!text && text !== "0") {
        return null;
    }
    text = cleanupNumberText(text, locale);
    const match = regex.exec(text);
    if (!match || (match && match.input === "")) {
        return currentValue;
    }
    const value = Number(match[0]);
    return changeLimitRange(value, targetField.params);
};
exports.clipboardTextToSlider = clipboardTextToSlider;
const clipboardSliderToSelf = (clipboardValue, srcField, targetField, userPreferences, currentValue) => {
    const { text, rawValue } = clipboardValue;
    const value = rawValue !== null && rawValue !== void 0 ? rawValue : text;
    const numValue = value ? Number(value) : targetField.params.required ? 1 : 0;
    return changeLimitRange(numValue, targetField.params);
};
exports.clipboardSliderToSelf = clipboardSliderToSelf;
const changeLimitRange = (value, parameters) => {
    var _a, _b, _c;
    const maxValue = (_a = parameters.max_value) !== null && _a !== void 0 ? _a : 0;
    const minValue = (_b = parameters.min_value) !== null && _b !== void 0 ? _b : 0;
    const increment = (_c = parameters.value_increment) !== null && _c !== void 0 ? _c : 1;
    value = increment * Math.round(value / increment);
    if (value > maxValue) {
        value = maxValue;
    }
    if (value < minValue) {
        value = minValue;
    }
    return value;
};
function clipboardToSelf(clipboardValue, _srcField, _targetField, _userPreferences) {
    const { text, rawValue } = clipboardValue;
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    return rawValue || text;
}
exports.clipboardToSelf = clipboardToSelf;
const clipboardNumberToRating = (clipboardValue, srcField, targetField) => {
    var _a;
    const scale = (_a = targetField.params.scale) !== null && _a !== void 0 ? _a : 1;
    const value = clipboardValue.rawValue;
    if (value === undefined || value === null) {
        return 0;
    }
    if (value <= 0) {
        return 1;
    }
    if (value > scale) {
        return scale;
    }
    return value;
};
exports.clipboardNumberToRating = clipboardNumberToRating;
const clipboardTextToRating = (clipboardValue, srcField, targetField, userPreferences, currentValue) => {
    var _a;
    const newValueIsEmpty = !clipboardValue.text.replace(/\n/g, " ").trim();
    if (newValueIsEmpty && !targetField.params.required) {
        return 0;
    }
    const locale = userPreferences.locale.value;
    const text = cleanupNumberText(clipboardValue.text, locale);
    const scale = (_a = targetField.params.scale) !== null && _a !== void 0 ? _a : 1;
    const regex = (0, number_1.getNumberRegex)(1, true, false, false, userPreferences.locale.value);
    const match = regex.exec(text);
    if (!match || (match && match.input === "")) {
        return currentValue;
    }
    const value = Number(match[0]);
    if (value === 0) {
        return value;
    }
    if (!value) {
        return 0;
    }
    if (value <= 0) {
        return 1;
    }
    if (value > scale) {
        return scale;
    }
    return Math.round(value);
};
exports.clipboardTextToRating = clipboardTextToRating;
const clipboardTextToAutonumber = (clipboardValue, srcField, targetField, userPreferences, currentValue) => {
    const regex = (0, number_1.getNumberRegex)(0, false, false, false, userPreferences.locale.value);
    const locale = userPreferences.locale.value;
    const text = cleanupNumberText(clipboardValue.text, locale);
    const match = regex.exec(text);
    if (!match || (match && match.input === "")) {
        return currentValue;
    }
    return Number(match[0]);
};
exports.clipboardTextToAutonumber = clipboardTextToAutonumber;
const clipboardYesNoSelf = (clipboardValue) => {
    var _a;
    return (_a = clipboardValue.rawValue) !== null && _a !== void 0 ? _a : false;
};
exports.clipboardYesNoSelf = clipboardYesNoSelf;
const clipboardTextToYesNo = (clipboardValue, _srcField, _targetField, userPreferences, _currentValue) => {
    const newValueIsEmpty = !clipboardValue.text.trim();
    if (newValueIsEmpty) {
        return false;
    }
    // If text was copied from excel we have a metacharacters, i.e 'Yes\r\n'.
    // That is why we should remove them from the text.
    const text = clipboardValue.text.replace(/(\r\n|\n|\r)/gm, "");
    const isYes = checkYes(text);
    const isNo = checkNo(text);
    if (!isYes && !isNo) {
        const defaultValue = _targetField.params.default_value;
        if (newValueIsEmpty && _targetField.params.required && defaultValue) {
            return defaultValue;
        }
        return _currentValue;
    }
    return isYes;
};
exports.clipboardTextToYesNo = clipboardTextToYesNo;
const yesValues = [
    (0, intl_1.$t)(texts_1.yesNoFieldText.yes).toLocaleLowerCase(),
    (0, intl_1.$t)(texts_1.yesNoFieldText.true).toLocaleLowerCase(),
    (0, intl_1.$t)(texts_1.yesNoFieldText.y).toLocaleLowerCase(),
    (0, intl_1.$t)(texts_1.yesNoFieldText.on).toLocaleLowerCase(),
    (0, intl_1.$t)(texts_1.yesNoFieldText.selected).toLocaleLowerCase(),
    "1",
    "yes",
    "true",
    "y",
    "on",
    "selected",
];
const noValues = [
    (0, intl_1.$t)(texts_1.yesNoFieldText.no).toLocaleLowerCase(),
    (0, intl_1.$t)(texts_1.yesNoFieldText.false).toLocaleLowerCase(),
    (0, intl_1.$t)(texts_1.yesNoFieldText.n).toLocaleLowerCase(),
    (0, intl_1.$t)(texts_1.yesNoFieldText.off).toLocaleLowerCase(),
    "0",
    "no",
    "false",
    "n",
    "off",
];
const checkYes = (text) => {
    return yesValues.includes(text.toLocaleLowerCase());
};
const checkNo = (text) => {
    return noValues.includes(text.toLocaleLowerCase());
};
const cleanupNumberText = (text, locale) => {
    const decimalSeparator = (0, number_1.getDecimalSeparator)(locale);
    // remove all characters except numbers, decimal separator and minus sign
    text = text.replace(new RegExp(`[^\\d${decimalSeparator}-]`, "g"), "");
    // remove all minus signs except the first one
    text = text.replace(/-/g, (match, offset) => {
        return offset === 0 ? match : "";
    });
    text = text.replace(new RegExp(`\\${decimalSeparator}`, "g"), ".");
    // remove all separators except the last one
    text = text.replace(/([.,])[^.,]*\1/g, "$1");
    return text;
};
